import { useNavigate } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
import hero from '../../assets/images/heroImg.png';
import line from '../../assets/images/illus.svg';

import Button from '../Button/Button';

const Hero = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className='hero'>
        <div className='hero__left'>
          <Fade left duration={2000}>
            <h1>
              Learn any subject from top schools <br /> in the world
            </h1>
          </Fade>
          <p>
            <Fade left duration={3000}>
              Join other top performing students to learn on PL by Edves and ace
              all your subjects
            </Fade>
          </p>

          <Button
            className='primary-btn'
            text='Join For Free'
            onClick={() => navigate('/student-signup')}
          />
        </div>
        <div className='hero__right'>
          <img src={hero} alt='hero' />
        </div>
      </div>
      <div className='hero-line'>
        <img src={line} alt='' />
      </div>
    </>
  );
};

export default Hero;
